import React, { useEffect, useRef, useState } from "react";
import styles from "../mobilesignup2style.module.css";
import { Button, CircularProgress, TextField } from "@mui/material";
import { getFetch } from "../../../fetch/fetch";


const GetName: React.FC<any> = (props) => {

    const [disabled, setDisabled] = useState(true);
    const inputRef = useRef<HTMLInputElement>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        //이름이 2자 이상인지 확인
        const isValidName = props.name && props.name.length >= 2;

        setDisabled(!isValidName);

    }, [props.name]);

    const controlChange = (raw: string) => {

        if (!props.setName) {
            return;
        }

        props.setName(raw);

    };

    const submit = async () => {

        try{

            if(!props.value){
                alert("사용자 유형 정보가 없습니다. 다시 시도해주세요.");
                return;
            }

            if(props.value === "student" || props.value === "teacher"){
                //가입용 코드 물어보는 페이지로 이동
                props.setPage(6);
            }

            if(props.value === "parent"){
                //학생 전화번호 물어보는 페이지로 이동
                props.setPage(7);
            }

        }catch(e){
            console.log(e);
        }
        
    }

    //처음에 focus 처리
        useEffect(() => {
            if (inputRef && inputRef.current) {
                inputRef.current.focus();
            }
        }, [inputRef.current]);


    return (
        <div className={styles.mainContainer} style={{
            height: props.bodyHeight ? `${props.bodyHeight}px` : "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: props.pc ? "" : "space-between",
            // paddingBottom: "39px",
            paddingBottom : props.pc ? "" : "max(var(--safe-area-inset-bottom), 39px)",
        }}>
            <div style={{
                width: "100%",
                marginBottom : props.pc ? "30px" : "0px"
            }}>
                <div style={{
                    paddingTop: "28px",
                    color: "#202632",
                    fontFamily: "Apple_B",
                    fontSize: "24px",
                    lineHeight: "32px",
                    letterSpacing: "-2%",
                }}>
                    <br />이름을 입력해주세요
                </div>
                <div style={{
                    marginTop: "40px"
                }}>
                    <div>
                        <TextField
                            variant="standard"
                            label="이름"
                            fullWidth
                            type="text"
                            sx={{
                                "& .MuiInput-underline::before": {
                                    borderBottom: "1px solid #d3d3d3"
                                },
                                "& .MuiInput-underline": {
                                    height: "40px"
                                },
                                "& .MuiInputBase-input::placeholder": {
                                    fontFamily: "Apple_SB",
                                    color: "#d3d3d3"
                                },
                                "& .MuiInputBase-input": {
                                    fontFamily: "Apple_SB",
                                    color: "#202632",
                                    fontSize: "20px"
                                },
                            }}
                            value={props.name ? props.name : ""}
                            onChange={(e) => controlChange(e.target.value)}
                            inputRef={inputRef}
                        />
                    </div>
                </div>
            </div>
            <div>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: "#3d50b0",
                        height: "52px",
                        borderRadius: "13px",
                        fontWeight: 500,
                        fontFamily: "Apple_R",
                        boxShadow: "none !important",
                        '&.Mui-disabled': {
                            backgroundColor: '#C1d6f3',
                            color: "white"
                        },
                        "&:hover": {
                            backgroundColor: "#3d50b0",
                            boxShadow: "none",
                        },

                        "&:active": {
                            backgroundColor: "#3d50b0",
                        },

                        "&.Mui-focusVisible": {
                            backgroundColor: "#3d50b0",
                        }
                    }}
                    fullWidth
                    disabled={disabled}
                    onClick={() => {
                        submit();
                     }}
                >
                    확인
                </Button>
            </div>
        </div>
    )
}

export default GetName;